import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';


const { URL, API_KEY }: { URL: string; API_KEY: string; } = { URL: 'https://brindesapi.dilady.com.br/api/', API_KEY: 'aIf6EtKmTZvNdKhkEAHxSOJeze2b0WcSl0BJA6oZzjg' }
//const { URL, API_KEY }: { URL: string; API_KEY: string; } = { URL: 'http://localhost:55027/api/', API_KEY: 'aIf6EtKmTZvNdKhkEAHxSOJeze2b0WcSl0BJA6oZzjg' }


@Injectable()
export class Api {
    private _headers: Headers;

    constructor(private _http: Http) { }

    public get(endpoint: string): Observable<any> {
        return this._http.get(`${URL}${endpoint}`, { headers: this._getHeaders });
    }

    public post(endpoint: string, body: any): Observable<any> {
        return this._http.post(`${URL}${endpoint}`, body, { headers: this._getHeaders });
    }

    public put(endpoint: string, body: any): Observable<any> {
        return this._http.put(`${URL}${endpoint}`, body, { headers: this._getHeaders });
    }

    public delete(endpoint: string): Observable<any> {
        return this._http.delete(`${URL}${endpoint}`, { headers: this._getHeaders });
    }

    private get _getHeaders(): Headers {
        if (!this._headers) {
            this._headers = new Headers();

            this._headers.append('API_KEY', API_KEY);

            return this._headers;
        }

        return this._headers;
    }
}


// WEBPACK FOOTER //
// ./src/providers/api/api.ts